import React, { useState, useEffect } from 'react'
import CollapsableItem from './CollapsableItem'
import { useLocation } from 'react-router-dom'

export default function Collapsable(props) {
	const location = useLocation()
	const [active, setActive] = useState(
		location.pathname.includes(props.active_key)
	)

	useEffect(() => {
		const shouldBeActive = location.pathname.includes(props.active_key)
		setActive(prev => {
			if (prev !== shouldBeActive) return shouldBeActive
			return prev
		})
	}, [location.pathname, props.active_key])

	return (
		<li key={props.keyValue} class={`mb-1 sidebar-item sidebar-item-collapsable ${active ? 'active' : ''}`}>
			<button class={`btn btn-toggle align-items-center rounded collapsed ${active ? 'active' : ''}`} onClick={e => setActive(!active)}>
				<i class={`fas fa-fw ${props.icon}`} />
				<span> {props.title}</span>
				{(!props.collapsed || window.innerWidth < 768) && <i class={`fas fa-fw text-right ${active ? 'fa-chevron-up' : 'fa-chevron-down'}`} />}
			</button>
			<div class={`collapse ${active ? 'show' : ''}`}>
				<ul class='btn-toggle-nav list-unstyled fw-normal small'>
					{props.children.map((link, y) => {
						return (
							<CollapsableItem
								{...link}
								badge={
									props.badges.hasOwnProperty(link.badge?.key) &&
									props.badges[link.badge.key] !== 0 && (
										<span class={`badge bg-${link.badge?.color ?? 'light'} sidebar-menu-badge`}>{props.badges[link.badge.key]}</span>
									)
								}
								keyValue={`${props.keyValue}_${y}`}
								key={`${props.keyValue}_${y}`}
							/>
						)
					})}
				</ul>
			</div>
		</li>
	)
}
